import { Link } from 'react-router-dom';

export type DemoGuideItem = {
  step: string;
  title: string;
  description: string;
  to: string;
  icon: string;
  tag?: string;
};

export default function DemoGuideCard({ item }: { item: DemoGuideItem }) {
  return (
    <Link
      to={item.to}
      className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-6 hover:border-primary-400 transition-colors cursor-pointer"
    >
      <div className="flex items-center justify-between">
        <span className="w-12 h-12 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center text-2xl"><i className={item.icon}></i></span>
        <span className="font-label uppercase tracking-widest text-[11px] text-foreground-400">Step {item.step}</span>
      </div>
      <h3 className="mt-5 font-heading font-bold text-2xl text-foreground-950 leading-tight group-hover:text-primary-600 transition-colors">{item.title}</h3>
      <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{item.description}</p>
      {item.tag ? (
        <span className="mt-4 self-start bg-accent-100 text-accent-900 border border-accent-300 font-label font-bold uppercase tracking-widest text-[10px] px-2.5 py-1 rounded-sm">{item.tag}</span>
      ) : null}
      <span className="mt-5 inline-flex items-center gap-2 font-label uppercase tracking-widest text-xs font-bold text-primary-600 whitespace-nowrap">
        Open
        <span className="w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1"><i className="ri-arrow-right-line"></i></span>
      </span>
    </Link>
  );
}